import React from "react";
import styled from "styled-components";

import WP from "WP";

import SmartLink from "partials/SmartLink";
import Image from "partials/Image";
import GridElement from "partials/GridElement";
import Button from "partials/Button";
import FavoriteButton from "partials/FavoriteButton";

import Arrow from "icons/ArrowIcon";

export const MobileHotelCard = (props) => {
  const { hotel, getRooms, getDates, price, isFiltered, className } = props;

  return (
    <Wrapper key={hotel.id} className={className}>
      <SmartLink to={hotel.link}>
        <StyledImage
          image={hotel.acf.featured_image}
          background
          ratio='5:4.4'
        />
        <Title>{hotel.acf.item_name}</Title>
      </SmartLink>
      <InfoBox>
        <KeyFeatures>
          {hotel.acf.key_features.map((feature, idx) => {
            return <li key={idx}>{feature.feature_name.toUpperCase()}</li>;
          })}
        </KeyFeatures>
        <Grid>
          <PriceInfoGridElement colStart={1} colEnd={4} align='center'>
            {isFiltered && (
              <span>
                {getRooms} {WP.trans.rooms}, {getDates} {WP.trans.nights}
              </span>
            )}
            {price && <span>{price}</span>}
          </PriceInfoGridElement>
          <GridElement colStart={5} colEnd={6} align='center'>
            <SmartLink to={hotel.link}>
              <StyledButton>
                <Arrow />
              </StyledButton>
            </SmartLink>
          </GridElement>
          <GridElement colStart={7} colEnd={8} align='center'>
            <FavoriteButton sort={hotel.type} item={hotel} />
          </GridElement>
        </Grid>
      </InfoBox>
    </Wrapper>
  );
};

export default MobileHotelCard;

const Wrapper = styled.div``;

const StyledImage = styled(Image)`
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    content: "";
    background-color: transparent;
    transition: all 0.2s ease-in;
  }

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.2);
    }
    svg {
      opacity: 1;
    }
  }
`;

const Title = styled.span`
  display: block;
  ${(props) => props.theme.fonts.h3}
  padding: ${(props) => props.theme.spacing.contentM} 0 ${(props) =>
    props.theme.spacing.contentS};
  white-space: nowrap;
`;

const KeyFeatures = styled.ul`
  margin-bottom: ${(props) => props.theme.spacing.contentM};

  li {
    display: inline-block;
    position: relative;
    ${(props) => props.theme.p}
    font-size: 11px;
    line-height: 21px;
    font-weight: 600;

    &:after {
      content: "•";
      position: absolute;
      right: -10px;
      top: 0;
    }

    &:not(:first-of-type) {
      margin-left: ${(props) => props.theme.spacing.contentS};
    }

    &:last-of-type {
      &:after {
        content: "";
      }
    }
  }
`;
const InfoBox = styled.div``;

const Grid = styled.div`
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: (1fr 0.359fr) [3] 1fr;
  grid-template-columns: repeat(3, 1fr 0.359fr) 1fr;
`;

const PriceInfoGridElement = styled(GridElement)`
  span {
    display: block;
    ${(props) => props.theme.p}
  }
`;

const StyledButton = styled(Button)`
  svg {
    fill: ${(props) => props.theme.colors.negative};
  }
`;
